import { useEffect } from 'react'
import { __ListViewMode } from '../../../common/Dictionaries';

const useUpdateUserBookData = (usersBookData, setUsersBookData, filtredPartyArray, setFiltredPartyArray, inputParam_SelectedPartyCardId, tglListViewMode, inputParam_PartyCardIsSelected, inputParam_SetPartynCardIsSelected) => {    
    useEffect(()=> {
        const getData = async () => {
            try {
                const _subList = usersBookData.data.filter(x => x["partyId"] === inputParam_SelectedPartyCardId);
                setFiltredPartyArray(usersBookData.data && tglListViewMode === __ListViewMode.Specific ? {fireUpdate: true, data: _subList, pageNumber: 1, pageSize: 10, filters: []} : { fireUpdate: false, data: null })
                
                inputParam_SetPartynCardIsSelected && inputParam_SetPartynCardIsSelected(false)

                setUsersBookData(prevState => ({
                    ...prevState,
                    fireUpdate: false
                }));
            }
            catch (error) {
            }
        }
        
        if (usersBookData.data !== null && (inputParam_SelectedPartyCardId !== null && inputParam_PartyCardIsSelected === true && tglListViewMode === __ListViewMode.Specific)) {
            getData()
        }
    }, [usersBookData, setUsersBookData, filtredPartyArray, setFiltredPartyArray, inputParam_SelectedPartyCardId, tglListViewMode, inputParam_PartyCardIsSelected, inputParam_SetPartynCardIsSelected]);
}

export {
    useUpdateUserBookData
}